<template>
  <div class>
    <div class="select-question game-tf container wrap">
      <div class="select-question__left flex-grow-1 flex-basis-500">
        <div class="image animation-bottom margin-bottom-10">
          <image-loader :src="question.img"/>
        </div>
      </div>

      <div class="game-tf__answer flex-basis-600 flex-grow-1">
        <div class="select_question select_question-red container align-items-stretch">
          <div class="img container align-center">
            <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class>
          </div>
          <div class="flex-grow-1 bordered-box bordered-box-orange">
            <p>{{ question.question }}</p>
          </div>
        </div>

        <div class="game-tf__words">{{ question.text }}</div>

        <div class="game-tf__answer__option container">
          <button class="btn btn-rounded btn-green" @click="answer(true)">TRUE</button>
          <span class="flex-basis-100 flex-grow-1">or</span>
          <button class="btn btn-rounded btn-red" @click="answer(false)">FALSE</button>
        </div>

        <div class="game-tf__answer__result" v-show="question.answer!== null">
          <div
            class="game-tf__answer__result__text"
            :class="{ right: question.hit && question.answered, wrong: !question.hit && question.answered }"
          >
            <img src="@/assets/img/icons/check.svg" width="32" alt="Right" class="margin-right-10 img-result" v-show="question.hit && question.answered">
            <img src="@/assets/img/icons/cancel.svg" width="32" alt="Right" class="margin-right-10 img-result" v-show="!question.hit && question.answered">
            {{ question.answer }}
          </div>
        </div>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">
        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>
        <div v-if="question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta</span>
        </div>
        <div v-if="!question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta</span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>
<script>
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      supportMedia: false,
      talking: false,
      speech: null,
      index: 0,
      played: false,
      question: {},
      showInfo: false,
      showFeedback: false,
      ended: false
    };
  },
  computed: {
    ...mapGetters({
      testMode: 'isTestMode',
      isReview: 'isReview',
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    exercise() {
      return this.subTopic.exercise;
    }
  },
  props: {
    subTopic: {
      type: Object,
      default: () => ({})
    },
    topic: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  methods: {
    async setCurrent() {
      let qst = {},
        index = 0;
      const questions = this.exercise.questions;
      for (const q_key in questions) {
        index = q_key;
        if (!questions[q_key].answered) {
          if (!questions[q_key].answer)
            this.$set(this.exercise.questions[q_key], "answer", "");
          qst = questions[q_key];
          this.played = false;
          break;
        } else if (parseInt(q_key) == questions.length - 1) {
          this.ended = true;
          qst = questions[q_key];
          this.played = true;
        }
      }
      if (Object.keys(this.question).length == 0 || qst._id !== this.question._id) {
        this.index = index
        // await this.verifySource(qst)
        await this.$set(this, 'question', qst)
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    async save(question) {
      let copy = cloneDeep(question);
      let scoreQuestions = 0;
      let answered = 0;

      for (const qst of this.exercise.questions) {
        if (qst.answered) {
          if (qst.hit)
            scoreQuestions++;

          answered++;
        }
      }

      const score = (scoreQuestions * 100) / this.exercise.questions.length;

      let payload = {
        points: score,
        finished: false,
        question: { ...copy }
      };

      if (answered == this.exercise.questions.length) {
        payload.finished = true;
        this.ended = true;
        await this.$delay(1500)
        this.showInfo = true
        // if (!this.testMode && !this.isReview)
        //   await this.$store.dispatch("student/addXP", score);
      }

      gameBus.$emit("updateProgress", score);
      gameBus.$emit("setEnabled", true);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    },
    speak() {
      if (!this.talking && !this.question.answered) {
        this.speech.start();
      }
    },
    async answer (answer) {
      if (!this.question.answered) {
        this.$set(this.question, "answer", answer);
        this.$set(this.question, "hit", answer == this.question.correct);
        this.$set(this.question, "answered", true);
        this.feedback()
        await this.save(this.question);
      }
    },
    async viewQuestion(index) {
      const question = this.exercise.questions[index];
      if (question && question.answered) {
        this.index = index
        this.$set(this, 'question', question)

        if (!this.question.answer)
          this.$set(this.question, "answer", "");
      }
    },
    async feedback () {
      this.showFeedback = true
      await this.$delay(1500)
      this.showFeedback = false
      gameBus.$emit('setEnabled', true)
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    closeModal () {
      this.showInfo = false
    }
  },
  watch: {
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  mounted() {
    this.setCurrent()
    gameBus.$on("viewQuestion", this.viewQuestion)

    gameBus.$emit("updateProgress", this.subTopic.points)
    modalBus.$on("close", this.closeModal)
    gameBus.$on("setCurrent", this.setCurrent)
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion)

    modalBus.$off('close', this.closeModal)
    gameBus.$off("setCurrent", this.setCurrent)
  }
};
</script>
<style lang="scss">
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/answerSelectQuestion";

$color-red: #c2003c;

.game-tf {
  align-items: stretch;

  &__words {
    background: #70c6ff;
    border: 1px solid #0f8ddf;
    text-align: center;
    padding: 20px 10px;
    border-radius: 10px;
    font-size: 1.4rem;
    color: #fff;
    margin-bottom: 20px;
  }

  // &__img {
  //   padding: 10px;
  //   img {
  //     width: 100%;
  //     height: auto;
  //     border-radius: 15px;
  //   }
  // }
  &__answer {
    flex-basis: 35%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    &__question {
      font-weight: 600;
      font-size: 20px;
      padding: 10px;
      display: flex;
      justify-content: center;
      span {
        display: inline-block;
        align-self: center;
      }
    }
    &__option {
      width: 100%;
      align-items: center;
      justify-content: center;
      text-align: center;
      .btn {
        font-size: 1.4rem !important;
        margin: 5px;
        flex-basis: 120px;
      }

      @media (max-width: 520px) {
        flex-direction: column;
        span {
          flex-basis: 0;
        }
        .btn {
          width: 100%;
          flex-basis: 0;
          min-height: 50px;
        }
      }
    }
    &__result {
      display: flex;
      justify-content: center;
      align-items: stretch;
      flex-direction: column;
      margin-top: 20px;
      position: relative;
      &__text {
        flex-basis: 100%;
        width: 100%;
        padding: 20px;
        border-radius: 10px;
        text-align: center;
        border: 1px solid #000;
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 1px;
        display: none;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        position: relative;

        &.right {
          color: $color-green;
          border-color: $color-green;
          background: lighten($color-green, 40);
          display: inline-flex;
        }
        &.wrong {
          color: $color-red;
          border-color: $color-red;
          background: lighten($color-red, 40);
          display: inline-flex;
        }
      }
    }
  }
}

.feedback_icon {
  position: absolute;
  left: 20px;
  top: 12px;
}

.img-result {
  position: absolute;
  top: 16px;
  left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/trueOrFalseGame.vue